<div class="smooth-scrolling">
  
    <section class="offer-section" *ngIf="offersDiscountCatelogue && offersDiscountCatelogue.length > 0">
       
        <div class="row">
            <div class="col-12">
                <div class="store-title text-center">
                    <h4><b>offers</b> <i>for you </i></h4>
                </div>
            </div>
            <div class="col-lg-3 col-6 mb-3 offer-d"  *ngFor="let offers of offersDiscountCatelogue; let i = index;">
                <a (click)="redirectToShopAll(offers.url)">
                    <div class="offer-detail-img">
                        <img [src]="showImage(offers?.image_url1)" alt="img">
                    </div>
                </a>
            </div>
           
        </div>
    </section>

    

</div>